import React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { HtmlTooltip, StyledDarkRedInformationTypography } from "../../../../components/commonComponents/StyledComponents/styled";
import { Block, Close } from "@mui/icons-material";
import { stopLoopCampaignVisuals } from "../../../../api_calls/loopCampaign";
import { useSelector } from "react-redux";
import Confirmation from "../../../../components/commonComponents/Confirmation";
import { formatDate } from "../../../../api_calls/utils";
import { checkUserDetailsFromCookie, checkUserPermissions } from "../../../../api_calls/userManagement";
import ContentThumbnailWithPreview from "./thumbnail/ContentThumbnailWithPreview";

const ActiveInactiveVisualsList = ({ loopInfo, usedFor }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const checkUserDetails = checkUserDetailsFromCookie();
    const allowedAccessRights = checkUserPermissions();
    const permissionScope = allowedAccessRights.allowed_access;

    let userDetailObj = {};
    if (checkUserDetails.success === true) {
        userDetailObj = checkUserDetails.user_detail;
    }

    const [showPlayoutStopConfirmation, setShowPlayoutStopConfirmation] = React.useState(false);
    const [stopVisualDetail, setStopVisualDetail] = React.useState({});
    const [removeVisualDetail, setRemoveVisualDetail] = React.useState({});
    const [showPlayoutRemoveConfirmation, setShowPlayoutRemoveConfirmation] = React.useState(false);

    return (
        <>
            {/* -------- active/inactive visuals list if usedFor===update */}
            {
                typeof currentStateData.loop_campaign_visuals !== "undefined" && (
                    <Stack direction={"column"} spacing={5} alignItems={"flex-start"}>
                        {
                            currentStateData.loop_campaign_visuals.filter(visual => visual.active === true).length > 0 && (
                                <Box width={"100%"}>
                                    {/* -------- active visuals ---------- */}
                                    <StyledDarkRedInformationTypography variant="body3">
                                        Active Visuals
                                    </StyledDarkRedInformationTypography>
                                    <Box height={10} />
                                    {/* --------- active visuals list -------- */}
                                    <Box display="flex" flexWrap="wrap" gap={2}>
                                        {
                                            currentStateData.loop_campaign_visuals.filter(visual => visual.active === true).map(visual => {
                                                return (
                                                    <Box key={visual.id} position="relative">

                                                        {/* ------ remove button only visible for scheduled visuals ---- */}
                                                        {
                                                            loopInfo.status === "Scheduled" ? (
                                                                <div style={{ position: "relative" }}>
                                                                    <ContentThumbnailWithPreview
                                                                        visualInfo={visual}
                                                                    />
                                                                    {
                                                                        usedFor === "listReview" &&
                                                                        permissionScope.picture_list_can_edit === true && loopInfo.active === true &&
                                                                        (
                                                                            (userDetailObj.current_workspace?.id === loopInfo.loop_company_id) ||
                                                                            userDetailObj.user_type === "cyreen" ||
                                                                            userDetailObj.current_workspace?.name === loopInfo.retailer_company_name
                                                                        ) && (
                                                                            <HtmlTooltip title={"Remove Visual"}>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setRemoveVisualDetail({
                                                                                            visual_id: visual.id,
                                                                                        });
                                                                                        setShowPlayoutRemoveConfirmation(true);
                                                                                    }}
                                                                                    sx={{
                                                                                        position: "absolute",
                                                                                        top: -14,
                                                                                        right: -4,
                                                                                        background: "#E6E6E6",
                                                                                        color: "#AF3241",
                                                                                        '&:hover': {
                                                                                            background: "#AF3241",
                                                                                            color: "#E6E6E6"
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <Close
                                                                                        fontSize="small"
                                                                                    />
                                                                                </IconButton>
                                                                            </HtmlTooltip>
                                                                        )
                                                                    }

                                                                </div>
                                                            ) : (
                                                                <div style={{ position: "relative" }}>
                                                                    {/* ---- visual thumbnail with preview ---- */}
                                                                    <ContentThumbnailWithPreview
                                                                        visualInfo={visual}
                                                                    />
                                                                    {/* ---- stop playout button ---- */}
                                                                    {
                                                                        usedFor === "listReview" &&
                                                                        loopInfo.status === "Active" &&
                                                                        permissionScope.picture_list_can_edit === true && loopInfo.active === true &&
                                                                        (
                                                                            (userDetailObj.current_workspace?.id === loopInfo.loop_company_id) ||
                                                                            userDetailObj.user_type === "cyreen" ||
                                                                            userDetailObj.current_workspace?.name === loopInfo.retailer_company_name
                                                                        ) && (
                                                                            <HtmlTooltip title={"Stop Visual"}>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setStopVisualDetail({
                                                                                            visual_id: visual.id,
                                                                                        });
                                                                                        setShowPlayoutStopConfirmation(true);
                                                                                    }}
                                                                                    sx={{
                                                                                        position: "absolute",
                                                                                        top: -14,
                                                                                        right: -4,
                                                                                        background: "#E6E6E6",
                                                                                        color: "#AF3241",
                                                                                        '&:hover': {
                                                                                            background: "#AF3241",
                                                                                            color: "#E6E6E6"
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <Block
                                                                                        fontSize="small"
                                                                                    />
                                                                                </IconButton>
                                                                            </HtmlTooltip>

                                                                        )
                                                                    }

                                                                </div>
                                                            )
                                                        }
                                                    </Box>
                                                )
                                            })
                                        }
                                    </Box>
                                </Box>
                            )
                        }

                        {/* ----------- inactive list -------- */}
                        {
                            currentStateData.loop_campaign_visuals.filter(visual => visual.active === false).length > 0 && (
                                <Box width={"100%"}>
                                    <StyledDarkRedInformationTypography variant="body3">
                                        Stopped Visuals
                                    </StyledDarkRedInformationTypography>
                                    <Box height={10} />
                                    {/* --------- stopped visuals list -------- */}
                                    <Box display="flex" flexWrap="wrap" gap={2}>
                                        {
                                            currentStateData.loop_campaign_visuals.filter(visual => visual.active === false).map(visual => {
                                                return (
                                                    <Stack direction={"column"} key={visual.id} spacing={1} alignItems={"start"}>
                                                        <ContentThumbnailWithPreview
                                                            visualInfo={visual}
                                                        />
                                                        <Typography sx={{ fontSize: "12px" }}>
                                                            Stopped on: {formatDate(visual.date_end)}
                                                        </Typography>
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Box>

                                </Box>
                            )
                        }
                    </Stack>
                )
            }

            {/* ------- stop playout confirmation -------- */}
            {showPlayoutStopConfirmation === true && (
                <Confirmation
                    showConfirmationPopup={showPlayoutStopConfirmation}
                    closePopup={(e) => {
                        setStopVisualDetail({});
                        setShowPlayoutStopConfirmation(false);
                    }}
                    confirmationActionCall={() => {
                        stopLoopCampaignVisuals(loopInfo.id, stopVisualDetail.visual_id, "stop_playout")
                            .then((response) => {
                                if (response.success === true) {
                                    setStopVisualDetail({});
                                    setShowPlayoutStopConfirmation(false);
                                }
                            })
                            .catch((error) => {
                                console.error("Error stopping visual playout:", error);
                            });

                    }}
                    confirmationMessage={
                        <>
                            <Typography variant="body2">
                                You are about to permanently stop the playout of the visual.
                            </Typography>
                            <Box height={5} />
                            <Typography variant="body2">
                                This action cannot be undone.
                            </Typography>
                            <Box height={10} />
                            <Typography variant="body2">Are you sure you want to proceed?</Typography>
                        </>
                    }
                    confirmationTitle={"Stop Visual"}
                />
            )}

            {/* ------------ remove visual confirmation -------- */}
            {showPlayoutRemoveConfirmation === true && (
                <Confirmation
                    showConfirmationPopup={showPlayoutRemoveConfirmation}
                    closePopup={(e) => {
                        setRemoveVisualDetail({});
                        setShowPlayoutRemoveConfirmation(false);
                    }}
                    confirmationActionCall={() => {
                        stopLoopCampaignVisuals(loopInfo.id, removeVisualDetail.visual_id, "remove")
                            .then((response) => {
                                if (response.success === true) {
                                    setRemoveVisualDetail({});
                                    setShowPlayoutRemoveConfirmation(false);
                                }
                            })
                            .catch((error) => {
                                console.error("Error removing visual playout:", error);
                            });

                    }}
                    confirmationMessage={
                        <>
                            <Typography variant="body2">
                                Removing the visual will permanently delete it from this campaign.
                            </Typography>
                            <Box height={5} />
                            <Typography variant="body2">
                                This cannot be undone.
                            </Typography>
                            <Box height={10} />
                            <Typography variant="body2">Are you sure you want to proceed?</Typography>
                        </>
                    }
                    confirmationTitle={"Remove Visual"}
                />
            )}
        </>
    );
};

export default ActiveInactiveVisualsList;
